import { render, staticRenderFns } from "./ItemEvent.vue?vue&type=template&id=de220aa0"
import script from "./ItemEvent.vue?vue&type=script&lang=js"
export * from "./ItemEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports